import { Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { TooltipProps } from '../../DeckPlanCustomizationPanel/styles';
import { primary } from '@/theme/colors';
import { theme } from '@/theme/theme';
import { useAtom } from 'jotai';
import { showWorkscopeOverlayIcons as showWorkscopeOverlayIconsAtom } from '@/components/Analysis/modules/CustomBlocks/state';

export const DeckplanOverlayWorkscopeToggle = () => {
  const [showWorkscopeOverlayIcons, setShowWorkscopeOverlayIcons] = useAtom(
    showWorkscopeOverlayIconsAtom
  );
  return (
    <Tooltip title={'Workscope'} arrow placement="right" componentsProps={TooltipProps}>
      <FormControlLabel
        sx={{ width: 'fit-content' }}
        control={
          <Checkbox
            checked={showWorkscopeOverlayIcons}
            // disabled={!showWorkscopeOverlayIcons}
            onChange={() => setShowWorkscopeOverlayIcons((prev) => !prev)}
            sx={{
              color: primary.main,
              '&.Mui-checked': {
                color: theme.palette.common.darkBlue,
              },
            }}
          />
        }
        label={'Workscope'}
      />
    </Tooltip>
  );
};
